
<div ref="quillWrapper" class="quillWrapper" :style="wrapper">
  <slot name="toolbar"></slot>
  <div
    ref="quillContainer"
    :class="{
      'ql-container': true,
      chatOpen: chat,
      'no-horizontal-scroll': true,
    }"
    :style="settings.font"
    spellcheck="false"
  ></div>
  <AddAbbreviation ref="addAbb" />
</div>
